function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 0a4.015 4.015 0 00-1 7.9V9c0 1.7-1.2 2-5 2a12.149 12.149 0 00-5 .7V8c0-.1 0-.2.2-.2.1 0 .2-.1.3-.1A3.974 3.974 0 104.6.3a3.996 3.996 0 00-2.3 5.1v.1a3.819 3.819 0 002.5 2.3c.1 0 .2.1.2.3V16c0 .1 0 .2-.2.2s-.3.1-.5.2A3.862 3.862 0 002 19.6a3.398 3.398 0 00.3 2 3.978 3.978 0 002.6 2.3 3.854 3.854 0 002.6-.2A3.895 3.895 0 009.8 21a3.404 3.404 0 000-2 3.824 3.824 0 00-2.7-2.8c-.1 0-.2-.1-.2-.3V15c0-1.7 1.3-2 5-2 3 0 7 0 7-4V7.9a3.967 3.967 0 003-3.9A3.865 3.865 0 0018 0zm0 6.2A2.2 2.2 0 1120.2 4 2.22 2.22 0 0118 6.2z"
});

function SvgSpCiBranch(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "spCIBranch.d03fe.svg";
export { SvgSpCiBranch as ReactComponent };